import { FC } from 'react';
import styled from 'styled-components';
import { useEditorData } from '../../lib/FabricJs';
import { useHandleHistory } from '../../lib/FabricJs/hooks/useHandleHistory';
import { createQrObjectForSlide } from '../../lib/FabricJs/utils/qrObject';
import { editorTheme } from '../../theme';
import QrForm from './QrForm';

const Intro = styled.p`
  margin: 0 0 16px;
  font-size: 12px;
  line-height: 1.5;
  color: ${editorTheme.textMuted};
`;

const QrCodePanel: FC = () => {
  const { canvas } = useEditorData();
  const { handleHistory } = useHandleHistory();

  return (
    <>
      <Intro>
        Viewers scan the code with their phone camera. Test it with a phone
        before publishing.
      </Intro>
      <QrForm
        submitLabel="Add to slide"
        onSubmit={(settings) => {
          if (!canvas) return;
          const object = createQrObjectForSlide(canvas, settings);
          // @ts-ignore: recorded once below.
          object.auto = true;
          canvas.add(object);
          canvas.setActiveObject(object);
          canvas.requestRenderAll();
          handleHistory(canvas);
        }}
      />
    </>
  );
};

export default QrCodePanel;
